import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';

/** The survey answer page */
@Component({
	selector: 'app-appointment-note',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule
	],
	templateUrl: './appointment-note.component.html',
	styleUrl: './appointment-note.component.scss'
})
export class AppointmentNoteComponent implements OnInit, OnDestroy {

	constructor(private appointmentsService: AppointmentsService) {

	}

	getContent() {
		return JSON.stringify(this.appointmentsService.appointmentDetail.note??"",undefined,4).trim()
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}
}
